
























































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import http from "@/axios/http-common";
import moment from "moment";
import { storeAssesmenRisikoJatuh } from "@/store/modules/asesmenrisikojatuh";

@Component({
  components: {},
})
export default class RiwayatAsesmenRisikoJatuh extends Vue {
  @Prop() riwayatRisikoJatuh!: string;
  @Prop() rm!: string;
  // get stateRiwayatRisikoJatuh() {
  //   return storeAssesmenRisikoJatuh.riwayatRisikoJatuh;
  // }

  cetak() {
    const routeData =
      http.getAPI() + "/asesmen-risiko-jatuh-ralan/pasien/" + this.rm + "/pdf";
    window.open(routeData, "_blank");
  }

  getHumanDate(date) {
    return date
      ? moment(date, "YYYY-MM-DD HH:mm:ss").format("DD MMMM YYYY HH:mm:ss")
      : "";
  }
}
